import { render, staticRenderFns } from "./PurchasePropagate.vue?vue&type=template&id=7b07ba54&"
import script from "./PurchasePropagate.vue?vue&type=script&lang=js&"
export * from "./PurchasePropagate.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePropagate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports